// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlipayCircleOutlinedSvg from "@fishx/icons-svg/es/asn/AlipayCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var AlipayCircleOutlined = function AlipayCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlipayCircleOutlinedSvg
  }));
};

AlipayCircleOutlined.displayName = 'AlipayCircleOutlined';
export default React.forwardRef(AlipayCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AlipayCircleOutlined.js
// module id = 1961
// module chunks = 0